import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAlertasAbertosPublico } from "./services";

export interface FetchAlertasPublicoParams {
  idLoja: number;
  idCliente: number;
  apiKey: string;
  pagina?: number;
  itensPorPagina?: number;
}

export const actionGetAlertasAbertosPublico = createAsyncThunk(
  "ACTION_GET_ALERTAS_ABERTOS_PUBLICO",
  async (params: FetchAlertasPublicoParams) => {
    return getAlertasAbertosPublico(
      params.idLoja,
      params.idCliente,
      params.apiKey,
      params.pagina ?? 1,
      params.itensPorPagina ?? 50,
    );
  },
);
const sliceGetAlertasAbertosPublico = createSlice({
  name: "GET_ALERTAS_ABERTOS_PUBLICO",
  initialState: { status: "", data: [] } as any,
  reducers: {
    clearAlertsPublico: (state) => {
      state.data = [];
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionGetAlertasAbertosPublico.pending, (state) => {
        state.status = "loading";
      })
      .addCase(actionGetAlertasAbertosPublico.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload;
      })
      .addCase(actionGetAlertasAbertosPublico.rejected, (state) => {
        state.status = "error";
      });
  },
});

export const { clearAlertsPublico } = sliceGetAlertasAbertosPublico.actions;
export default sliceGetAlertasAbertosPublico.reducer;
